// Libs
import _isEqual from "lodash.isequal";
import debounceLodash from "lodash.debounce";
// Constants
import { CHIEF_ROLES } from "@/constants/judgeCodes";
import { JUDGE_ROLES } from "@/constants/roles";

export function isEqual<T>(value: T, other: T): boolean {
  return _isEqual(value, other);
}
export function debounce<T extends (..._args: any[]) => any>(func: T, wait: number) {
  return debounceLodash(func, wait);
}

export function isChiefJudge(judgeCode: string): boolean {
  return CHIEF_ROLES.includes(judgeCode as any);
}

export function isRoleChiefJudge(role: string): boolean {
  return role === JUDGE_ROLES.CHIEF_JUDGE;
}

export function isRoleJudge(role: string): boolean {
  return role === JUDGE_ROLES.JUDGE;
}

export function isValidRhythmicGroup(name: string): boolean {
  const validGroups = ["DA", "DB", "E", "A"];
  return validGroups.includes(name);
}

export function isMostJudgesPutBonus(judjesPoints: { bonus?: boolean }[]): boolean {
  const amountMoreHalfJudges = Math.floor(judjesPoints.length / 2) + 1;
  let amountJudgesPutBonus = judjesPoints.filter(({ bonus }) => bonus).length;

  return amountJudgesPutBonus >= amountMoreHalfJudges;
}

export function isString(value: unknown): value is string {
  return typeof value === "string";
}

export function isNumber(value: unknown): value is number {
  return typeof value === "number" && !Number.isNaN(value);
}

export function isUndefined(value: unknown): value is undefined {
  return value === undefined;
}
